import React, { useEffect, useState } from "react";
import { ProductCard } from "../components/ProductCard";
import { BundleSection } from "../components/BundleSection";
import { DonationSection } from "../components/DonationSection";
import { getProducts } from "../lib/api";
import { MaskLine } from "../components/Motion";

export default function Shop() {
  const [products, setProducts] = useState([]);
  useEffect(() => { getProducts().then(setProducts).catch(() => {}); }, []);
  return (
    <div className="max-w-[1500px] mx-auto px-4 sm:px-8 py-16 sm:py-24" data-testid="shop-page">
      <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-graytx mb-4">The First Drop · Limited run</p>
      <h1 className="font-display font-extrabold text-6xl sm:text-8xl uppercase leading-[0.85]">
        <MaskLine>Shop</MaskLine>
      </h1>
      <div className="grid sm:grid-cols-2 gap-6 sm:gap-10 mt-14">
        {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
      </div>
      <BundleSection />
      <DonationSection />
    </div>
  );
}
